module.exports = __webpack_public_path__ + "static/media/authen-banner.1564b242.jpg";